var PaymentFieldType;
(function (PaymentFieldType) {
    PaymentFieldType["TEXT"] = "TEXT";
    PaymentFieldType["SELECT"] = "SELECT";
    PaymentFieldType["PASSWORD"] = "PASSWORD";
    PaymentFieldType["HOSTED"] = "HOSTED";
    PaymentFieldType["CUSTOM"] = "CUSTOM";
})(PaymentFieldType || (PaymentFieldType = {}));

export { PaymentFieldType };
